module.exports = __webpack_public_path__ + "media/images/flags/32/Tuvalu-8712c97abf31b378f3213856e6590c9e.png";